import { OverlayContainer } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';
import { Client } from '@df/core/service/client';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalOverlayContainer extends OverlayContainer {
    private client = inject(Client);

    private subscriptions = new Subscription();

    protected override _createContainer(): void {
        this.subscriptions.add(
            this.client.rootElement$.subscribe(target => {
                if (target?.tagName === 'HTML' && typeof document !== 'undefined') {
                    target = document.body;
                }

                const containerClass = 'cdk-overlay-container';

                if (this._platform.isBrowser) {
                    const oppositePlatformContainers = this._document.querySelectorAll(`.${containerClass}[platform="server"]`);

                    // Remove any old containers from the opposite platform.
                    // This can happen when transitioning from the server to the client.
                    for (let i = 0; i < oppositePlatformContainers.length; i++) {
                        oppositePlatformContainers[i].remove();
                    }
                }

                if (target) {
                    if (!this._containerElement) {
                        this._containerElement = this._document.createElement('div');
                        this._containerElement.classList.add(containerClass);
                    }

                    target.appendChild(this._containerElement);
                } else {
                    super._createContainer();
                }
            })
        );
    }

    override ngOnDestroy(): void {
        this.subscriptions.unsubscribe();

        super.ngOnDestroy();
    }
}
